<template>
	<v-app :style="customStyleVar">
		<transition
			:name="transitionName"
			mode="out-in"
			@before-enter="onEnter"
			@before-leave="onLeave"
			@after-enter="afterEnter"
		>
			<router-view v-if="!blockScreen" class="page" />
		</transition>
	</v-app>
</template>

<script>

import { isEmail, isEmpty } from '@/constants/validators';

export default {
	name: "App",

	data: () => ({
		transitionName: "slide-x-reverse-transition",
		enterTransition: "slide-x-reverse-transition",
		leaveTransition: "slide-x-transition",
		styleObserver: null
	}),

	created(){
		this.getCustomConfig();
	},

	destroyed() {
		if(this.styleObserver){
			this.styleObserver.disconnect();
		}
	},

	computed: {
		confirmation: {
			get() {
				return this.$store.state.customization.confirmation;
			},

			set(newValue) {
				this.$store.commit("customization/setConfirmation", newValue);
			}
		},

		blockScreen: {
			get() {
				return this.$store.state.customization.blockScreen;
			},

			set(newValue) {
				this.$store.commit("customization/setBlockScreen", newValue);
			}
		},

		email: {
			get() {
				return this.$store.state.auth.email;
			},

			set(newValue) {
				this.$store.commit("auth/setEmail", newValue);
			}
		},

		backgroundColorBar: {
			get() {
				return this.$store.state.customization.backgroundColorBar;
			}
		},

		shadowLogin: {
			get() {
				return this.$store.state.customization.shadowLogin;
			}
		},

		customStyleVar(){
			return {
				'--bg-color': this.backgroundColor,
				'--shadow-color': this.shadowLogin,
				'--bg-color-bar': this.backgroundColorBar
			}
		}
	},

	methods: {
		getCustomConfig() {
			this.blockScreen = true;

			let subdomain = this.findSubdomain();

			if(["siliconhost", "server-homolog", "localhost", "pagstream", "sandbox"].includes(subdomain)){
				subdomain = null;
			}

			if (subdomain != null) {
				this.$store.dispatch("customization/getMerchantInformation", subdomain);
			} else {
				this.blockScreen = false;
			}
		},

		findSubdomain() {
			let host = window.location.hostname;
			let subdomain = window?.pagstream?.subdomain ?? host.split('.')[0];

			return subdomain;
		},

		onEnter(){
			this.transitionName = this.leaveTransition;
		},

		onLeave(){
			this.transitionName = this.enterTransition;
		},

		afterEnter(){
			window.scrollTo({ top: 0, behavior: 'smooth' });
		}
	},

	watch: {
		$route: {
			handler(to, from) {
				const toDepth = to.meta.depth;
				const fromDepth = from.meta.depth;

				if(this.confirmation){
					if(toDepth > fromDepth){
						if(this.leaveTransition != "slide-x-reverse-transition"){
							this.transitionName = "slide-x-reverse-transition";
						}
						this.enterTransition = "slide-x-transition";
						this.leaveTransition = "slide-x-reverse-transition";
					} else {
						if(this.leaveTransition != "slide-x-transition"){
							this.transitionName = "slide-x-transition";
						}
						this.enterTransition = "slide-x-reverse-transition";
						this.leaveTransition = "slide-x-transition";
					}
					return;
				}

				if(toDepth > fromDepth || fromDepth == undefined){
					if(this.leaveTransition != "slide-x-transition"){
						this.transitionName = "slide-x-transition";
					}
					this.enterTransition = "slide-x-reverse-transition";
					this.leaveTransition = "slide-x-transition";
				}else{
					if(this.leaveTransition != "slide-x-reverse-transition"){
						this.transitionName = "slide-x-reverse-transition";
					}
					this.enterTransition = "slide-x-transition";
					this.leaveTransition = "slide-x-reverse-transition";
				}
			}
		}
	}
}

</script>

<style lang="scss">

@import "@/scss/index.scss";

</style>